import React from 'react';
import { MdUndo, MdRedo } from 'react-icons/md';
import SavingStatusIndicator from '@/components/notes/SavingStatusIndicator';
import BackToLatestButton from '@/components/form/fields/mdx/toolbar/BackToLatestButton';
import ToggleVersionsPanelButton from '@/components/form/fields/mdx/toolbar/ToggleVersionsPanelButton';
import FullscreenToggle from '@/components/template/FullscreenToggle';
import { useNoteContext } from '@/components/notes/context/NoteContext';
import NoteEncryptionControl from '@/components/notes/NoteEncryptionControl';

interface TxtToolbarButtonsProps {
  onUndo: () => void;
  onRedo: () => void;
}

const TxtToolbarButtons: React.FC<TxtToolbarButtonsProps> = ({ onUndo, onRedo }) => {
  const { isReadOnly } = useNoteContext();

  return (
    <div className="flex flex-wrap items-center gap-y-1 p-0 w-full">

      {/* Left: Undo / Redo */}
      <div className={`flex items-center space-x-1 ${isReadOnly ? 'pointer-events-none opacity-40' : ''}`}>
        <button
          type="button"
          onClick={onUndo}
          className="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-400 transition-colors"
          title="Undo (Ctrl+Z)"
          aria-label="Undo"
        >
          <MdUndo size={18} />
        </button>
        <button
          type="button"
          onClick={onRedo}
          className="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-400 transition-colors"
          title="Redo (Ctrl+Y)"
          aria-label="Redo"
        >
          <MdRedo size={18} />
        </button>
      </div>

      {/* Right: meta controls */}
      <div className="flex items-center gap-1 sm:ml-auto shrink-0">
        <SavingStatusIndicator />
        <NoteEncryptionControl />
        <BackToLatestButton />
        <div className="hidden sm:block w-px h-4 bg-gray-300 dark:bg-gray-600 mx-1" />
        <div className="hidden sm:flex">
          <ToggleVersionsPanelButton />
        </div>
        <div className="hidden sm:block w-px h-4 bg-gray-300 dark:bg-gray-600 mx-1" />
        <FullscreenToggle />
      </div>

    </div>
  );
};

export default TxtToolbarButtons;
